import { TextControlProps } from "types";
import TextControl from "../text-control/text-control";

type PasswordControlProps = Omit<TextControlProps, "type" | "autoComplete">;

const PasswordControl = (props: PasswordControlProps) => {
    return (
        <TextControl {...props} autoComplete="current-password" type="password" />
    );
};

export default PasswordControl;